/* import __COLOCATED_TEMPLATE__ from './conversation-routing.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();